import { render } from "./MyVespaDetails.vue?vue&type=template&id=da2fee34"
import script from "./MyVespaDetails.vue?vue&type=script&lang=js"
export * from "./MyVespaDetails.vue?vue&type=script&lang=js"

import "@/assets/scss/views/MyVespa.scss?vue&type=style&index=0&lang=scss"
import "@/assets/scss/views/Account.scss?vue&type=style&index=1&lang=scss"
script.render = render

export default script